exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".regular-media svg[data-v-40a12da1]{left:50%;pointer-events:none;position:absolute;top:50%;transform:translate(-50%,-50%);z-index:1}", ""]);

